import axiosInstance from '../Api/axiosInstance';

// Get all lists for a company
export const getLists = (companyId) =>
	axiosInstance.post('/lists/all', { companyId });

// Get a specific list by ID
export const getListById = (id, companyId) =>
	axiosInstance.post(`/lists/${id}`, { companyId });

// Get list statistics
export const getListStats = (id, companyId) =>
	axiosInstance.post(`/lists/${id}/stats`, { companyId });

// Create a new list
export const createList = (listData, companyId) =>
	axiosInstance.post('/lists', { ...listData, companyId });

// Update an existing list by ID
export const updateList = (id, listData, companyId) =>
	axiosInstance.put(`/lists/${id}`, { ...listData, companyId });

// Move list to folder
export const moveListToFolder = (id, folder, companyId) =>
	axiosInstance.put(`/lists/${id}/move`, { folder, companyId });

// Duplicate a list
export const duplicateList = (id, newName, companyId) =>
	axiosInstance.post(`/lists/${id}/duplicate`, { newName, companyId });

// Delete a list by ID
export const deleteList = (id, companyId) =>
	axiosInstance.delete(`/lists/${id}`, { data: { companyId } });
